// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v8.2.4',
  USERDATA_KEY: 'rkgd5f2ab4c9d34',
  apiUrl: 'https://api-pay-dev.theparkingapp.us',
  paymentPageUrl: 'https://pay-dev.theparkingapp.us',
  appThemeName: 'Metronic',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
